export default __webpack_public_path__ + "static/media/chervon-white.848f20e6.svg";